export const infoWindowReducer = (state = null, action) => {
    switch (action.type) {
        case 'infoWindow':
            return action.payload
        default:
            return state
    }
}
export default infoWindowReducer;